import { useDispatch, useSelector } from 'react-redux';
import { Dialog, styled, Typography } from '@mui/material';
import AlertModel from '../AlertModal';
import { RootState } from '../../../redux/store';
import { modelAction } from '../../../redux/models/modelsSlice';
import { theme as Apptheme } from '../../../theme/theme';

const TransparentDialog = styled(Dialog)(() => ({
  '& .MuiDialog-paper': {
    backgroundColor: 'transparent',
    boxShadow: 'none',
  },
}));

const PermissionDeniedAlertModel = () => {
  const modelState = useSelector((state: RootState) => state.model);
  const dispatch = useDispatch();
  const handleClose = () => {
    dispatch(modelAction.setIsPermissionDeniedModelOpen(false));
  };

  return (
    <TransparentDialog open={modelState.isPermissionDeniedModelOpen} onClose={handleClose}>
      <AlertModel
        type="error"
        title="Permission Denied!"
        message={
          <Typography variant="tableRowRegular" textAlign="center" color={Apptheme.palette.shades.lightDark}>
            <span>You do not have the necessary </span>
            <br />
            <span>rights to perform this action. Please </span>
            <br />
            <span>contact your Administrator for </span>
            <br />
            <span>assistance</span>
          </Typography>
        }
        onClickCancel={handleClose}
        cancelText="Dismiss"
      />
    </TransparentDialog>
  );
};

export default PermissionDeniedAlertModel;
